<i class="mc-checkbox-checkmark mc mc-check_16"></i>
<i class="mc-checkbox-mixedmark mc mc-minus_16"></i>
